import { getAuthToken } from 'modules/auth';

const appendJWTToken = async (headers: object): Promise<object> => {
  try {
    const JWToken = await getAuthToken();

    // Includes the JWToken if it's in the component state
    if (JWToken) {
      return { ...headers, Authorization: `Bearer ${JWToken}` };
    }
    return headers;
  } catch (e) {
    // console.error('Error appending JWToken', e);
    return headers;
  }
};

export default appendJWTToken;
